module.exports = __webpack_public_path__ + "static/media/(LH)-11-Capim-Dourado-bijuterias.662eb058.jpg";